// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box; }

body {
  background: #0D1821;
  color: #F0F4EF; }

.radial-menu {
  position: relative;
  width: 300px;
  height: 300px;
  border: 1px dashed red;
  pointer-events: all; }
  .radial-menu .toggle {
    width: 25%;
    height: 25%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background: #344966;
    z-index: 2;
    transition: all .3s ease;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center; }
    .radial-menu .toggle.active {
      transform: translate(-50%, -50%) scale(1.05);
      border: 1px solid #F0F4EF; }
  .radial-menu .button {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 50px;
    height: 50px;
    background: #BFCC94;
    color: #0D1821;
    border-radius: 50%;
    transform: rotate(-20deg);
    opacity: 0;
    transition: all .1s linear;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 1.1rem; }
    .radial-menu .button.active {
      opacity: 1; }
    .radial-menu .button:hover {
      cursor: pointer; }
  .radial-menu .button-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-75deg); }
    .radial-menu .button-container.active {
      transform: translate(-50%, -50%) rotate(0deg); }
`, "",{"version":3,"sources":["webpack://./src/stylesheets/style.scss"],"names":[],"mappings":"AAGA;EACE,sBAAsB,EAAA;;AAGxB;EACE,mBAAmB;EACnB,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAA;EALrB;IAOI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,wBAAwB;IAKxB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAA;IAxB3B;MAkBM,4CAA4C;MAC5C,yBAAyB,EAAA;EAnB/B;IA4BI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IAOV,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB,EAAA;IAjDrB;MAuCM,UAAU,EAAA;IAvChB;MA0CM,eAAe,EAAA;EA1CrB;IAoDI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,+CAA+C,EAAA;IAvDnD;MAyDM,6CAA6C,EAAA","sourcesContent":["@import 'components/index';\n\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  background: #0D1821;\n  color: #F0F4EF;\n}\n\n.radial-menu {\n  position: relative;\n  width: 300px;\n  height: 300px;\n  border: 1px dashed red;\n  pointer-events: all;\n  .toggle {\n    width: 25%;\n    height: 25%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 50%;\n    background: #344966;\n    z-index: 2;\n    transition: all .3s ease;\n    &.active {\n      transform: translate(-50%, -50%) scale(1.05);\n      border: 1px solid #F0F4EF;\n    }\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .button {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 50px;\n    height: 50px;\n    background: #BFCC94;\n    color: #0D1821;\n    border-radius: 50%;\n    transform: rotate(-20deg);\n    opacity: 0;\n    &.active {\n      opacity: 1;\n    }\n    &:hover {\n      cursor: pointer;\n    }\n    transition: all .1s linear;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 1.1rem;\n  }\n  .button-container {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%) rotate(-75deg);\n    &.active {\n      transform: translate(-50%, -50%) rotate(0deg);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
